<template>
  <div class="d-flex flex-column align-start">
    <v-text-field
      class="mt-3"
      :model-value="modelValue || 123456789"
      readonly
      style="width: 100%;"
      density="comfortable"
      aria-label="hashed MFA key"
      :type="isMasked ? 'password' : 'text'"
    />
    <!-- <v-text-field
      class="mt-3"
      label="API Key"
      :model-value="123211221211"
      readonly
      style="width: 100%;"
      density="comfortable"
    /> -->
    <v-btn
      color="primary"
      :loading="loading"
      @click="handleClick"
      :aria-label="`${field.label}`"
    >
      {{ field.label }}
    </v-btn>

    
  </div>
</template>

<script setup>
import { ref } from 'vue'
const isMasked = ref(true)

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  field: Object,
  modelValue: String,
  onClick: {
    type: Function,
    default: null
  }
})

const loading = ref(false)

const handleClick = async () => {
  if (!props.onClick) return

  loading.value = true
  try {
    await props.onClick()
  } finally {
    isMasked.value = false
    loading.value = false
  }
}
</script>